import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";
import BreadCrump from "../tools/breadcrump"

import * as React from 'react';
import TissEditor from '../Editor/TissEditor';
import ImageUploader from '../tools/uploaderImage';
import ImageUploaders from '../tools/uploaderimages';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import HeaderOfPage from '../tools/headerOfPage';

type LanguageCode = 'ku' | 'fa' | 'en' | 'ar' | 'tr';

interface MultilingualField {
    ku: string;
    fa: string;
    en: string;
    ar: string;
    tr: string;
    [key: string]: string;
}

// Helper function to safely access multilingual fields
const getMultilingualValue = (field: MultilingualField | string | undefined, lang: LanguageCode): string => {
    if (!field) return '';
    if (typeof field === 'string') return field;
    return field[lang] || '';
};

export default function EditGallery() {
    let cookie = getCookies();
    const { t } = useTranslation();

    let { Id } = useParams();
    const [cookies, setCookie] = useCookies<any>(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    const [activeLang, setActiveLang] = useState<LanguageCode>('en');
    const languages: Array<{ code: LanguageCode; label: string }> = [
        { code: 'ku' as LanguageCode, label: 'Kurdish' },
        { code: 'fa' as LanguageCode, label: 'فارسی' },
        { code: 'en' as LanguageCode, label: 'English' },
        { code: 'ar' as LanguageCode, label: 'العربية' },
        { code: 'tr' as LanguageCode, label: 'Türkçe' }
    ];

    const [data, setData] = React.useState<any>(null);
    const save =async () => {
        try {
            var path = `${config.url}/v1/dashboard/gallery/${data.id}`;

            let res = await axios({
                method: 'put',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire('Saved');
        } catch (error) {

        }
    }
    const load = async () => {
        try {
            var path = `${config.url}/v1/dashboard/gallery/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            let loadedData = res.data.message;
            
            // Ensure multilingual structure exists
            const ensureMultilingual = (field: any): MultilingualField => {
                if (!field) return { ku: '', fa: '', en: '', ar: '', tr: '' };
                if (typeof field === 'string') {
                    return { ku: field, fa: field, en: field, ar: field, tr: field };
                }
                if (typeof field === 'object') {
                    // Migrate old nl to ku if present
                    if (field.nl !== undefined) {
                        field.ku = field.nl;
                        delete field.nl;
                    }
                    return {
                        ku: field.ku || '',
                        fa: field.fa || '',
                        en: field.en || '',
                        ar: field.ar || '',
                        tr: field.tr || ''
                    };
                }
                return { ku: '', fa: '', en: '', ar: '', tr: '' };
            };
            
            loadedData.name = ensureMultilingual(loadedData.name);
            loadedData.title = ensureMultilingual(loadedData.title);
            loadedData.text = ensureMultilingual(loadedData.text);
            loadedData.keywords = ensureMultilingual(loadedData.keywords);
            loadedData.description = ensureMultilingual(loadedData.description);
            
            setData(loadedData);
        } catch (error) {

        }
    }
    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Blog',
            url: '/dashboard/Blog'
        },
        {
            name: 'Group List',
            url: '/dashboard/Blog/list'
        },
        {
            name: 'Edit Group',
            url: null
        }
    ]
    useEffect(() => {
        load();
    }, []);
    return (
        <div className='directions'>

            <BreadCrump data={breadcrump}></BreadCrump>

                <HeaderOfPage name="ویرایش گالری"></HeaderOfPage>


            {
                data != null && <div className='grid grid-cols-1 text-right sm:grid-cols-5 '>
                    <div >

                        <div className=" bg-black rounded-[10px] p-5">
                            <h4 className="text-white text-[20px] font-bold ">{ t('Edit Detail Image') }</h4>
                            <hr />
                            <form key={key}>
                                {/* Language Selector */}
                                <div className="max-w-sm space-y-3">
                                    <label className="text-white">زبان / Language</label>
                                    <div className="flex gap-2 flex-wrap">
                                        {languages.map((lang) => (
                                            <button
                                                key={lang.code}
                                                type="button"
                                                onClick={() => setActiveLang(lang.code)}
                                                className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${
                                                    activeLang === lang.code
                                                        ? 'bg-blue-600 text-white'
                                                        : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                                                }`}
                                            >
                                                {lang.label}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{ t('Name') } ({languages.find(l => l.code === activeLang)?.label})</label>
                                    <input
                                        value={getMultilingualValue(data.name, activeLang)}
                                        type="text"
                                        className={`${inputstyle}     ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Name"
                                        onChange={(e) => setData({ 
                                            ...data, 
                                            name: { 
                                                ...data.name, 
                                                [activeLang]: e.target.value 
                                            } 
                                        })}
                                    />
                                    {error != null && error['url'] != undefined && <small>{error['name']['message']}</small>}
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{ t('Slug') }  </label>
                                    <input
                                        type="text"
                                        value={data.url}
                                        className={`${inputstyle}       ${error != null && error['url'] != undefined && `bg-red-100`}  `}
                                        placeholder="Slug"
                                        onChange={(e) => setData({ ...data, url: e.target.value })}
                                    />
                                    {error != null && error['url'] != undefined && <small>{error['url']['message']}</small>}
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{ t('Title') } ({languages.find(l => l.code === activeLang)?.label})</label>
                                    <input
                                        value={getMultilingualValue(data.title, activeLang)}
                                        type="text"
                                        className={inputstyle}
                                        placeholder="Title"
                                        onChange={(e) => setData({ 
                                            ...data, 
                                            title: { 
                                                ...data.title, 
                                                [activeLang]: e.target.value 
                                            } 
                                        })}
                                    />
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{ t('Text') } ({languages.find(l => l.code === activeLang)?.label})</label>
                                    <textarea
                                        value={getMultilingualValue(data.text, activeLang)}
                                        className={inputstyle}
                                        onChange={(e) => setData({ 
                                            ...data, 
                                            text: { 
                                                ...data.text, 
                                                [activeLang]: e.target.value 
                                            } 
                                        })}
                                        placeholder="..." />
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{ t('Keywords') } ({languages.find(l => l.code === activeLang)?.label})</label>
                                    <textarea
                                        value={getMultilingualValue(data.keywords, activeLang)}
                                        className={inputstyle}
                                        onChange={(e) => setData({ 
                                            ...data, 
                                            keywords: { 
                                                ...data.keywords, 
                                                [activeLang]: e.target.value 
                                            } 
                                        })}
                                        placeholder="..." />
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{ t('Description') } ({languages.find(l => l.code === activeLang)?.label})</label>
                                    <textarea
                                        value={getMultilingualValue(data.description, activeLang)}
                                        className={inputstyle}
                                        onChange={(e) => setData({ 
                                            ...data, 
                                            description: { 
                                                ...data.description, 
                                                [activeLang]: e.target.value 
                                            } 
                                        })}
                                        placeholder="..." />
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <button type="button"
                                        onClick={(e) => { save() }}
                                        className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:focus:bg-white/20 dark:focus:text-white"
                                    > { t('Update') } 
                                         
                                    </button>

                                </div>
                            </form>
                            <div className='mt-3'>
                                <div className="text-white ">{ t('Thumpnail') }  </div>
                                <ImageUploader id={data.id} component={'gallerypost'}></ImageUploader>


                            </div>


                        </div>
                    </div>
                    <div className='col-span-1 sm:col-span-4 p-5'>
                        

                        <div className="mt-3">
                        <div id="unstyled-tabs-2" role="tabpanel" aria-labelledby="unstyled-tabs-item-2">
                                <TissEditor component='gallerypost' parent={data.id} />

                            </div>
                            <div id="unstyled-tabs-1" role="tabpanel" aria-labelledby="unstyled-tabs-item-1">
                                <ImageUploaders count={1000} id={data.id} component={'GalleryComponent'}></ImageUploaders>

                            </div>
                           

                        </div>
                    </div>
                </div>
            }

        </div>
    )
}